<template>
  <panel :title="title" :onClick="onSelect" :withBody="isDisplayDetails" :withFooter="isDisplayDetails" :to="{ name: 'order', params: { identifier: order.marketplace.identifier, code: order.marketplace.code } }">
    <span slot="header-right" class="badge" :class="order.status">{{ $t(order.status).label }}</span>
    <div>
      <div class="l-row">
        <div class="l-col-6@md l-col-offset-3@md">
          <stepper :order="order.marketplace"/>
        </div>
      </div>
      <div class="l-row">
        <blockquote class="l-col-4@md box first">
          <div class="l-row" v-if="order.customer">
            <div class="l-col-6@md">
              <div class="margin">
                <strong>{{ $t('name.label') }}</strong>
                {{ hideData(order.customer.name) | attribute}}
              </div>
              <div class="margin">
                <strong>{{ $t('phone.label') }}</strong>
                {{ hideData(order.customer.phone) | attribute }}
              </div>
            </div>
            <div class="l-col-6@md">
              <div class="margin">
                <strong>{{ isPersonal ? 'CPF' : 'CNPJ' }}</strong>
                {{ hideData(order.customer.documentNumber) | attribute}}
              </div>
              <div class="margin">
                <strong>{{ $t('phoneMobile.label') }}</strong>
                {{ hideData(order.customer.mobile) | attribute }}
              </div>
            </div>
          </div>
          <div class="l-row full-height u-textCenter" v-else>
            <div class="l-col-12@md">
              <div class="vertical-center">
                <span>Dados do cliente não informados</span>
              </div>
            </div>
          </div>
        </blockquote>
        <blockquote class="l-col-4@md box">
          <div class="l-row">
            <div class="l-col-6@md attributes">
              <div class="margin">
                <strong>{{ $t('identifier.label') }}</strong>
                {{ order.marketplace.externalReference | attribute}}
              </div>
              <div class="margin">
                <strong>{{ $t('date.label') }}</strong>
                {{ adjustDate | attribute }}
              </div>
            </div>
            <div class="l-col-6@md">
              <div class="margin">
                <strong>{{ $t('shipmentService.name.label') }}</strong>
                <span class="badge queue">{{ $t(`shipmentService.${order.marketplace.shipmentService}.label`) | attribute}}</span>
              </div>
              <div class="margin">
                <strong>{{ $t('channel.label') }}</strong>
                {{ channel | attribute }}
              </div>
              <slot name="attributes"/>
            </div>
          </div>
        </blockquote>
        <blockquote class="l-col-4@md">
          <div class="l-row">
            <div class="l-col-6@md">
              <div class="margin">
                <strong>{{ $t('subtotal.label') }}</strong>
                {{ order.payment.subtotal | currency | attribute}}
              </div>
              <div class="margin">
                <strong>{{ $t('shippingPrice.label') }}</strong>
                {{ order.payment.shipping | currency | attribute }}
              </div>
            </div>
            <div class="l-col-6@md">
              <div class="margin">
                <strong>{{ $t('discount.label') }}</strong>
                {{ order.payment.discount | currency | attribute}}
              </div>
              <div class="margin">
                <strong>{{ $t('total.label') }}</strong>
                <code>{{ order.payment.total | currency | attribute}}</code>
              </div>
            </div>
          </div>
        </blockquote>
      </div>
    </div>
    <div slot="footer">
      <module-icon :identifier="order.marketplace.identifier"/>
    </div>
  </panel>
</template>

<script>
  import { mapActions } from 'vuex'
  import Stepper from '@/components/Order/Shared/Stepper'
  import Panel from '@/components/template/Panel'
  import ModuleIcon from '@/components/template/ModuleIcon'

  export default {
    props: {
      order: {
        type: Object,
        required: true
      }
    },
    methods: {
      ...mapActions('itemsSelected', [
        'add',
        'remove'
      ]),
      onSelect (selected) {
        this.$children[0].selected = selected
        if (selected) {
          this.add(this.order)
        } else {
          this.remove(this.order)
        }
      },
      hideData (data) {
        if (this.order.shipping.postDate) {
          let postDate = new Date(this.order.shipping.postDate)
          let limitDateToHideData = new Date(postDate.setDate(postDate.getDate() + 28)).toISOString()
          let todayDate = new Date().toISOString()
          if (data !== null && data !== '' && this.order.marketplace.identifier === 'amazon' && todayDate > limitDateToHideData) {
            let firstLetter = data.substr(0, 1)
            let lastLetter = data.substr(-1, 1)
            let star = '*'
            if (data.length > 3) {
              return `${firstLetter}${star.repeat(data.length)}${lastLetter}`
            } else {
              return `${star.repeat(data.length)}`
            }
          }
        }
        return data
      }
    },
    computed: {
      isDisplayList () {
        return this.listInitial === 'displayList'
      },
      listInitial () {
        return this.$parent.listInitial
      },
      isDisplayDetails () {
        return this.listInitial === 'displayDetails'
      },
      title () {
        let title = []

        if (this.order.marketplace.externalReference) {
          if (this.order.expediter.code) {
            title.push(`#${this.order.marketplace.externalReference} (${this.order.expediter.code})`)
          } else {
            title.push(`#${this.order.marketplace.externalReference}`)
          }
        }

        if (this.listInitial === 'displayList') {
          if (this.order.customer && this.order.customer.name) {
            title.push(`Nome: ${this.order.customer.name}`)
          }

          if (this.order.marketplace.channel) {
            title.push(`Canal: ${this.order.marketplace.channel}`)
          }

          if (this.order.payment.total) {
            title.push(`Total: ${this.$options.filters.currency(this.order.payment.total)}`)
          }
        }

        return title.join(' | ')
      },
      isPersonal () {
        return this.order.customer.type === 'personal'
      },
      channel () {
        if (this.order.marketplace.identifier === 'mercadoLivre') {
          return `${this.order.marketplace.channel} (${this.order.marketplace.account.nickname})`
        }
        return this.order.marketplace.channel
      },
      adjustDate () {
        const currentDate = this.order.marketplace.date
        const orderMarketplaceDate = new Date(currentDate)

        orderMarketplaceDate.setHours(orderMarketplaceDate.getHours())
        return `${('0' + orderMarketplaceDate.getDate()).slice(-2)}/${('0' + (orderMarketplaceDate.getMonth() + 1)).slice(-2)}/${orderMarketplaceDate.getFullYear()} ${orderMarketplaceDate.getHours()}:${orderMarketplaceDate.getMinutes()}`
      }
    },
    components: {
      Panel,
      ModuleIcon,
      Stepper
    }
  }
</script>

<style lang="sass" scoped>
  blockquote.first
    border-color: transparent

  strong
    display: block
    margin-bottom: 5px

  .margin
    margin: 10px 0 15px 10px
</style>



// WEBPACK FOOTER //
// OrderCard.vue?934de694